export const ENTITIES = {
  CONVERSATION: 'CONVERSATION',
  MEMBER: 'MEMBER',
  MESSAGE: 'MESSAGE',
  SST: 'SST',
  SPACE_OBJECT: 'SPACE_OBJECT',
  USER: 'USER',
  DEDICATED_FORUM: 'DEDICATED_FORUM',
  DEDICATED_FORUM_MESSAGE: 'DEDICATED_FORUM_MESSAGE',
};

export type Entity = (typeof ENTITIES)[keyof typeof ENTITIES];
